import { render } from "./allocation.vue?vue&type=template&id=21bb2ef0&scoped=true"
import script from "./allocation.vue?vue&type=script&lang=js"
export * from "./allocation.vue?vue&type=script&lang=js"

import "./allocation.vue?vue&type=style&index=0&id=21bb2ef0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-21bb2ef0"
/* hot reload */
if (module.hot) {
  script.__hmrId = "21bb2ef0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('21bb2ef0', script)) {
    api.reload('21bb2ef0', script)
  }
  
  module.hot.accept("./allocation.vue?vue&type=template&id=21bb2ef0&scoped=true", () => {
    api.rerender('21bb2ef0', render)
  })

}

script.__file = "src/components/allocation.vue"

export default script